import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row mt-2" }
const _hoisted_4 = {
  for: "isActive",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_5 = { class: "col-sm-8 form-check form-switch d-flex align-items-center" }
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = {
  for: "currency",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_8 = { class: "col-sm-8" }
const _hoisted_9 = { class: "row mt-2" }
const _hoisted_10 = {
  for: "method",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_11 = { class: "col-sm-8" }
const _hoisted_12 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_13 = { class: "d-flex flex-row align-items-center gap-1" }
const _hoisted_14 = { class: "row mt-2" }
const _hoisted_15 = { class: "col-sm-12 col-form-label text-center text-capitalize-first" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = {
  for: "dayTradesCountLimit",
  class: "col-sm-3 col-form-label pe-2 text-capitalize-first"
}
const _hoisted_18 = { class: "col-sm-3" }
const _hoisted_19 = {
  for: "monthTradesCountLimit",
  class: "col-sm-3 col-form-label ps-2 text-capitalize-first"
}
const _hoisted_20 = { class: "col-sm-3" }
const _hoisted_21 = { class: "row mt-2" }
const _hoisted_22 = {
  for: "dayTradesSumLimit",
  class: "col-sm-3 col-form-label text-capitalize-first pe-2"
}
const _hoisted_23 = { class: "col-sm-3" }
const _hoisted_24 = {
  for: "monthTradesSumLimit",
  class: "col-sm-3 col-form-label text-capitalize-first ps-2"
}
const _hoisted_25 = { class: "col-sm-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.form.isActive ? _ctx.helper.trans('requisites.active') : _ctx.helper.trans('requisites.inactive')), 1),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.isActive) = $event)),
              id: "isActive",
              class: "form-check-input",
              style: {"cursor":"pointer"},
              type: "checkbox",
              role: "switch"
            }, null, 512), [
              [_vModelCheckbox, _ctx.form.isActive]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.helper.trans("labels.currency")), 1),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Multiselect, {
              id: "currency",
              class: "",
              modelValue: _ctx.form.currency,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.currency) = $event)),
              options: _ctx.store.getters['currencyMethods/currencies'],
              "custom-label": (opt) => `${opt}`,
              multiple: false,
              "select-label": "Select",
              placeholder: ""
            }, null, 8, ["modelValue", "options", "custom-label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.helper.trans("labels.payment_method")), 1),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_Multiselect, {
              id: "method",
              class: "",
              modelValue: _ctx.form.method,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.method) = $event)),
              modelModifiers: { number: true },
              options: _ctx.store.getters['currencyMethods/methods'](_ctx.form.currency),
              "custom-label": (opt) => _ctx.helper.trans(`pay_methods.${opt}`),
              multiple: false,
              "select-label": "Select",
              placeholder: ""
            }, {
              option: _withCtx((props) => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_PayMethodIcon, {
                    "icon-class": "icon",
                    method: props.option
                  }, null, 8, ["method"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                ])
              ]),
              singleLabel: _withCtx((props) => [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_PayMethodIcon, {
                    "icon-class": "icon",
                    method: props.option
                  }, null, 8, ["method"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "options", "custom-label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.helper.trans("labels.limits")), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.helper.trans("labels.daily_qty")), 1),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.dayTradesCountLimit) = $event)),
              "data-maska": "9 99#",
              "data-maska-tokens": "9:[0-9]:repeated",
              "data-maska-reversed": "",
              type: "text",
              required: "",
              class: "form-control",
              id: "dayTradesCountLimit"
            }, null, 512), [
              [_vModelText, _ctx.form.dayTradesCountLimit],
              [_directive_maska]
            ])
          ]),
          _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.helper.trans("labels.monthly_qty")), 1),
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.monthTradesCountLimit) = $event)),
              "data-maska": "9 99#",
              "data-maska-tokens": "9:[0-9]:repeated",
              "data-maska-reversed": "",
              type: "text",
              required: "",
              class: "form-control",
              id: "monthTradesCountLimit"
            }, null, 512), [
              [_vModelText, _ctx.form.monthTradesCountLimit],
              [_directive_maska]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.helper.trans("labels.daily_sum")), 1),
          _createElementVNode("div", _hoisted_23, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.dayTradesSumLimit) = $event)),
              "data-maska": "9 99#",
              "data-maska-tokens": "9:[0-9]:repeated",
              "data-maska-reversed": "",
              type: "text",
              class: "form-control",
              id: "dayTradesSumLimit"
            }, null, 512), [
              [_vModelText, _ctx.form.dayTradesSumLimit],
              [_directive_maska]
            ])
          ]),
          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.helper.trans("labels.monthly_sum")), 1),
          _createElementVNode("div", _hoisted_25, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.monthTradesSumLimit) = $event)),
              "data-maska": "9 99#",
              "data-maska-tokens": "9:[0-9]:repeated",
              "data-maska-reversed": "",
              type: "text",
              class: "form-control",
              id: "monthTradesSumLimit"
            }, null, 512), [
              [_vModelText, _ctx.form.monthTradesSumLimit],
              [_directive_maska]
            ])
          ])
        ])
      ])
    ])
  ]))
}